
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class CheckoutModal extends Vue {
  @Prop({ default: 'Confirm Action' }) readonly title!: string;
  @Prop({ required: true }) readonly message!: string;

  confirm (): void {
    this.$emit('confirmed')
  }

  cancel (): void {
    this.$emit('cancelled')
  }
}
